import React from "react"

import { ContentTag } from "scrivito"
import { ProjectsPage } from "scrivito/Objs/ProjectsPage/ProjectsPageObjClass"

import { useScrollController } from "features/scroll-management/model/useScrollController"

import { ProjectsOverviewPageView } from "./ProjectsOverviewPageView"
import { useProjectsOverviewPageModel } from "./hooks/useProjectsOverviewPageModel"

export const ProjectsOverviewPage = React.memo(
  ({ page }: { page: ProjectsPage }) => {
    useScrollController()

    const model = useProjectsOverviewPageModel()

    return (
      <ProjectsOverviewPageView
        {...model}
        title={
          <ContentTag content={page} attribute="title" aria-live="polite" />
        }
      />
    )
  }
)
